import React from 'react';
import { connect } from 'react-redux';
import ArrayHelper from 'foundation/array-helper';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import eventBus from 'general/js/event-bus';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import { LivePreMessage } from 'components/live-pre-message';
import CourseToggleView from './course-toggle-view';
import CourseTopPanel from './course-top-panel';
import CourseList from './course-list';
import CourseMap from './course-map';

//TODO: import from sublayout component
const SUBLAYOUT_FULLWIDTH_ENABLE = 'SUBLAYOUT_FULLWIDTH_ENABLE';
const SUBLAYOUT_FULLWIDTH_DISABLE = 'SUBLAYOUT_FULLWIDTH_DISABLE';

class CourseLayout extends React.Component {
    constructor(props) {
        super(props);

        this.contentToggleButton = {
            primaryContent: 'course map',
            changedView: 'hole list'
        };

        this.state = {
            primaryView: false,
        };
    }

    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.COURSE);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.COURSE);
    }

    toggleView = () => {
        if (!this.state.primaryView) {
            eventBus.emit(SUBLAYOUT_FULLWIDTH_ENABLE);
        } else {
            eventBus.emit(SUBLAYOUT_FULLWIDTH_DISABLE);
        }
        this.setState({ primaryView: !this.state.primaryView });
    }

    render() {
        const { scoringCourse } = this.props;

        if (scoringCourse === undefined) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        if (!scoringCourse || ArrayHelper.isEmpty(scoringCourse.holes)) {
            return <LivePreMessage />;
        }

        return (
            <div className="course">
                {
                    scoringCourse.sitecoreData &&
                    <div className="course__toggle-view-wrapper hidden">
                        <CourseToggleView
                            primaryView={this.state.primaryView}
                            content={this.contentToggleButton}
                            toggleView={this.toggleView}
                        />
                    </div>
                }
                {
                    this.state.primaryView &&
                    <CourseMap
                        holes={scoringCourse.holes}
                        courseMapSrc={scoringCourse.sitecoreData} />
                }
                {
                    !this.state.primaryView &&
                    <React.Fragment>
                        <CourseTopPanel />
                        <CourseList holes={scoringCourse.holes} />
                    </React.Fragment>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    scoringCourse: state.scoring[endpointNames.COURSE]
});

const CourseLayoutContainer = connect(
    mapStateToProps
)(CourseLayout);

export default CourseLayoutContainer;
